/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PowerConsumption
 */
export interface PowerConsumption {
    /**
     * for debugging
     * @type {Date}
     * @memberof PowerConsumption
     */
    cursor?: Date;
    /**
     * for debugging. The raw db row timestamp.
     * @type {Date}
     * @memberof PowerConsumption
     */
    rowValueUtc?: Date;
    /**
     * The truncated time in UTC for the beginning of the interval (eg 'January' 2022 would be `2021-12-31T16:00:00`
     * @type {Date}
     * @memberof PowerConsumption
     */
    timestamp?: Date;
    /**
     * Date label, to avoid timezone conversions in frontend. eg:
     * Hour: yyyy-MM-ddTHH:00:00
     * Day: yyyy-MM-dd
     * Week: 2022W01 (week-of-year, new weeks start on Sunday)
     * Month: 2022M01
     * @type {string}
     * @memberof PowerConsumption
     */
    label?: string;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    frequencyHz?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l1VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l2VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l3VoltageRmsV?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l1CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l2CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l3CurrentRmsA?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l1ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l2ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l3ActivePowerRmsW?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l1ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l2ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    l3ReactivePowerRmsVar?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    totalActiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    totalReactiveEnergyImportWh?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    totalActiveEnergyExportWh?: number;
    /**
     *
     * @type {number}
     * @memberof PowerConsumption
     */
    totalReactiveEnergyExportWh?: number;
}

/**
 * Check if a given object implements the PowerConsumption interface.
 */
export function instanceOfPowerConsumption(
    value: object,
): value is PowerConsumption {
    return true;
}

export function PowerConsumptionFromJSON(json: any): PowerConsumption {
    return PowerConsumptionFromJSONTyped(json, false);
}

export function PowerConsumptionFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PowerConsumption {
    if (json == null) {
        return json;
    }
    return {
        cursor: json["cursor"] == null ? undefined : new Date(json["cursor"]),
        rowValueUtc:
            json["rowValueUtc"] == null
                ? undefined
                : new Date(json["rowValueUtc"]),
        timestamp:
            json["timestamp"] == null ? undefined : new Date(json["timestamp"]),
        label: json["label"] == null ? undefined : json["label"],
        frequencyHz:
            json["frequencyHz"] == null ? undefined : json["frequencyHz"],
        l1VoltageRmsV:
            json["l1VoltageRmsV"] == null ? undefined : json["l1VoltageRmsV"],
        l2VoltageRmsV:
            json["l2VoltageRmsV"] == null ? undefined : json["l2VoltageRmsV"],
        l3VoltageRmsV:
            json["l3VoltageRmsV"] == null ? undefined : json["l3VoltageRmsV"],
        l1CurrentRmsA:
            json["l1CurrentRmsA"] == null ? undefined : json["l1CurrentRmsA"],
        l2CurrentRmsA:
            json["l2CurrentRmsA"] == null ? undefined : json["l2CurrentRmsA"],
        l3CurrentRmsA:
            json["l3CurrentRmsA"] == null ? undefined : json["l3CurrentRmsA"],
        l1ActivePowerRmsW:
            json["l1ActivePowerRmsW"] == null
                ? undefined
                : json["l1ActivePowerRmsW"],
        l2ActivePowerRmsW:
            json["l2ActivePowerRmsW"] == null
                ? undefined
                : json["l2ActivePowerRmsW"],
        l3ActivePowerRmsW:
            json["l3ActivePowerRmsW"] == null
                ? undefined
                : json["l3ActivePowerRmsW"],
        l1ReactivePowerRmsVar:
            json["l1ReactivePowerRmsVar"] == null
                ? undefined
                : json["l1ReactivePowerRmsVar"],
        l2ReactivePowerRmsVar:
            json["l2ReactivePowerRmsVar"] == null
                ? undefined
                : json["l2ReactivePowerRmsVar"],
        l3ReactivePowerRmsVar:
            json["l3ReactivePowerRmsVar"] == null
                ? undefined
                : json["l3ReactivePowerRmsVar"],
        totalActiveEnergyImportWh:
            json["totalActiveEnergyImportWh"] == null
                ? undefined
                : json["totalActiveEnergyImportWh"],
        totalReactiveEnergyImportWh:
            json["totalReactiveEnergyImportWh"] == null
                ? undefined
                : json["totalReactiveEnergyImportWh"],
        totalActiveEnergyExportWh:
            json["totalActiveEnergyExportWh"] == null
                ? undefined
                : json["totalActiveEnergyExportWh"],
        totalReactiveEnergyExportWh:
            json["totalReactiveEnergyExportWh"] == null
                ? undefined
                : json["totalReactiveEnergyExportWh"],
    };
}

export function PowerConsumptionToJSON(value?: PowerConsumption | null): any {
    if (value == null) {
        return value;
    }
    return {
        cursor:
            value["cursor"] == null ? undefined : value["cursor"].toISOString(),
        rowValueUtc:
            value["rowValueUtc"] == null
                ? undefined
                : value["rowValueUtc"].toISOString(),
        timestamp:
            value["timestamp"] == null
                ? undefined
                : value["timestamp"].toISOString(),
        label: value["label"],
        frequencyHz: value["frequencyHz"],
        l1VoltageRmsV: value["l1VoltageRmsV"],
        l2VoltageRmsV: value["l2VoltageRmsV"],
        l3VoltageRmsV: value["l3VoltageRmsV"],
        l1CurrentRmsA: value["l1CurrentRmsA"],
        l2CurrentRmsA: value["l2CurrentRmsA"],
        l3CurrentRmsA: value["l3CurrentRmsA"],
        l1ActivePowerRmsW: value["l1ActivePowerRmsW"],
        l2ActivePowerRmsW: value["l2ActivePowerRmsW"],
        l3ActivePowerRmsW: value["l3ActivePowerRmsW"],
        l1ReactivePowerRmsVar: value["l1ReactivePowerRmsVar"],
        l2ReactivePowerRmsVar: value["l2ReactivePowerRmsVar"],
        l3ReactivePowerRmsVar: value["l3ReactivePowerRmsVar"],
        totalActiveEnergyImportWh: value["totalActiveEnergyImportWh"],
        totalReactiveEnergyImportWh: value["totalReactiveEnergyImportWh"],
        totalActiveEnergyExportWh: value["totalActiveEnergyExportWh"],
        totalReactiveEnergyExportWh: value["totalReactiveEnergyExportWh"],
    };
}
